import { FormStore, GlobalStore } from '@roc/feature-app-core';
import { action, flow, makeObservable, observable } from 'mobx';
import { VendorCompanyProfileStore } from './vendorCompanyProfileStore';
import { ExternalAgentLoanService } from '../services/externalAgentLoanService';

const bankInformationfields = {
  fields: {
    beneficiaryAccountName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The account name is required.',
    },
    beneficiaryRoutingNumber: {
      value: '',
      error: null,
      rule: 'required|regex:/^\\d+$/',
      message: 'The Routing number must be 9 digits long',
    },
    beneficiaryAccountNumber: {
      value: '',
      error: null,
      rule: 'required|regex:/^\\d+$/',
      message: 'The account number is required',
    },
    beneficiaryBankName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The bank name is required.',
    },
    streetName: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The street name is required.',
    },
    city: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The city is required.',
    },
    zipCode: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The zip code is required.',
    },
    state: {
      value: '',
      error: null,
      rule: 'required',
      message: 'The state is required.',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
}


export class VendorBankInformationStore {
  globalStore: GlobalStore;
  vendorCompanyProfileStore: VendorCompanyProfileStore;
  bankInformationFormStore: FormStore;
  activeStep: number;
  loading: boolean = false;
  service: ExternalAgentLoanService;

  constructor(globalStore: GlobalStore, vendorCompanyProfileStore: VendorCompanyProfileStore) {
    this.globalStore = globalStore;
    this.vendorCompanyProfileStore = vendorCompanyProfileStore;
    this.bankInformationFormStore = new FormStore(bankInformationfields, globalStore);
    this.activeStep = 0;
    this.service = new ExternalAgentLoanService();
    makeObservable(this, {
      bankInformationFormStore: observable,
      activeStep: observable,
      loading: observable,
      goNextStep: action,
      goPrevStep: action,
      moveToStep: action,
      generateDocument: flow,
      fillContactInformation: action,
    });
  }

  *generateDocument(signature) {
    try {
      const values = this.bankInformationFormStore.getFormValues();
      const data = {
        ...values,
        signature: signature,
        userAgent: navigator.userAgent,
        companyId: this.vendorCompanyProfileStore.companyInformation?.companyId,
      }
      yield this.service.generateBankDetailsDocument(data);
      this.goNextStep();
    } catch (error) {
      console.log(error);
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while generating document.',
      });
    }
  }

  goPrevStep() {
    this.activeStep--;
  }

  goNextStep() {
    this.activeStep++;
  }

  moveToStep(step) {
    this.activeStep = step;
  }


  fillContactInformation() {
    if (this.vendorCompanyProfileStore.companyInformation?.zipCode) {
      this.bankInformationFormStore.onFieldChange('zipCode', this.vendorCompanyProfileStore.companyInformation?.zipCode);
    }
    if (this.vendorCompanyProfileStore.companyInformation?.city) {
      this.bankInformationFormStore.onFieldChange('city', this.vendorCompanyProfileStore.companyInformation?.city);
    }
    if (this.vendorCompanyProfileStore.companyInformation?.streetName) {

      this.bankInformationFormStore.onFieldChange('streetName', this.vendorCompanyProfileStore.companyInformation?.streetName);
    }
    if (this.vendorCompanyProfileStore.companyInformation?.state) {
      this.bankInformationFormStore.onFieldChange('state', this.vendorCompanyProfileStore.companyInformation?.state);
    }
  }

}
